import React, { useMemo, useState, useEffect } from 'react';
import Highcharts from 'highcharts';
import HC_more from 'highcharts/highcharts-more';
import HighchartsReact from 'highcharts-react-official';

HC_more(Highcharts);

export default function PieChart({ data = [] }) {
  const [screenWidth, setScreenWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);

  // Monitor de redimensionamento para manter a responsividade da legenda
  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const options = useMemo(() => {
    // Mapeamento direto: se a API filtrou por regional, o 'data' já virá atualizado
    const chartData = data.map(item => ({
      name: item['feature_label_pt'],
      y: item.accesses
    }));

    return {
      chart: {
        type: 'pie',
        backgroundColor: 'transparent'
      },
      credits: { enabled: false },
      title: { text: null },
      tooltip: {
        pointFormat: 'Acessos: <b>{point.y}</b>'
      },
      series: [
        {
          name: 'Funcionalidades',
          colorByPoint: true,
          data: chartData,
          innerSize: '40%'
        }
      ],
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false,
            format: '{point.y}',
            style: {
              fontWeight: 'bold',
              textOutline: 'none',
              fontSize: '12px'
            },
            distance: 15
          },
          showInLegend: true
        }
      },
      legend: {
        enabled: true,
        align: 'right',
        verticalAlign: 'middle',
        layout: 'vertical',
        itemMarginBottom: 10,
        itemStyle: {
          fontSize: '11px',
          fontWeight: 'normal'
        },
        // Configuração de largura para evitar que legendas longas cortem
        width: screenWidth > 768 ? 400 : undefined
      },
      responsive: {
        rules: [
          {
            condition: { maxWidth: 768 },
            chartOptions: {
              legend: {
                align: 'center',
                verticalAlign: 'bottom',
                layout: 'horizontal',
                width: '100%'
              }
            }
          }
        ]
      }
    };
  }, [data, screenWidth]);

  // Caso os dados ainda estejam carregando
  if (!data || data.length === 0) {
    return <div style={{ textAlign: 'center', padding: '20px' }}>Aguardando dados...</div>;
  }

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={options}
    />
  );
}
